
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppHeader from '@/components/AppHeader.vue'
import AppLoadingCircular from '@/components/AppLoadingCircular.vue'
import HomeAppItem from '@/components/HomeAppItem.vue'
import HomeSearch from '@/components/HomeSearch.vue'
import HomeFilters from '@/components/HomeFilters.vue'
import HomeAppHeaderTable from '@/components/HomeAppHeaderTable.vue'
import HomeHeader from '@/components/HomeHeader.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { cloneDeep } from 'lodash'

@Component({
    name: 'Home',
    components: {
        AppHeader,
        AppLoadingCircular,
        FontAwesomeIcon,
        HomeAppItem,
        HomeSearch,
        HomeFilters,
        HomeAppHeaderTable,
        HomeHeader,
    },
})
export default class Home extends Vue {
    get apps() {
        return this.$store.state.home.apps
    }

    get isLoading(): boolean {
        return this.$store.state.home.isLoading
    }

    get isEmptyResult(): boolean {
        return this.$store.state.home.apps.length === 0 && !this.isLoading
    }

    get filters() {
        return this.$store.state.home.filters
    }

    public async mounted() {
        const queryFilter = this.parseFilters()
        this.$store.dispatch('home/filterApps', queryFilter)
        this.scroll()
    }

    public beforeDestroy() {
        window.onscroll = () => {
            // Remove infinity
        }
    }

    public goToDetailApp(id: number) {
        this.$router.push(`/app/${id}`)
    }

    @Watch('filters')
    public buildQuery(newValue: any, _: any)  {
        this.$router.replace({ query: {
            brand_id: newValue.brandId,
            brand_name: newValue.brandName,
            platform: newValue.platform,
            status: newValue.status,
            tab: newValue.tab,
        }}).catch(() => {
            // Ignore exception
        })
    }

    private parseFilters() {
        const query = cloneDeep(this.filters)
        const brandName = this.$route.query.brand_name
        const brandId = this.$route.query.brand_id
        const platform = this.$route.query.platform
        const status = this.$route.query.status
        const tab = this.$route.query.tab

        if (typeof brandName === 'string') {
            query.brandName = brandName
        }

        if (typeof brandId === 'string') {
            query.brandId = brandId
        }

        if (typeof platform === 'string') {
            query.platform = platform
        }

        if (typeof status === 'string') {
            query.status = status
        }

        if (typeof tab === 'string') {
            query.tab = tab
        }

        return query
    }

    private scroll() {
        window.onscroll = () => {
            const bottomOfWindow =
                document.documentElement.scrollTop + window.innerHeight >=
                document.documentElement.offsetHeight
            if (bottomOfWindow) {
                this.$store.dispatch('home/fetchApps')
            }
        }
    }
}
